import { Component, inject, signal } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

const secureGodotHost = 'monicaanderic.com';
const localHosts = new Set(['localhost', '127.0.0.1']);

@Component({
  selector: 'ag-godot-demo',
  standalone: true,
  imports: [],
  templateUrl: './godot-demo.component.html',
  styleUrl: './godot-demo.component.css'
})
export class GodotDemoComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly sanitizer = inject(DomSanitizer);

  readonly roomCode = this.route.snapshot.paramMap.get('roomCode')?.toUpperCase() ?? '';
  readonly mode = (this.route.snapshot.data['mode'] as string | undefined) ?? 'screen';
  readonly shellClass = 'godot-shell';
  readonly secureRedirectUrl = this.getSecureRedirectUrl();
  readonly godotSrc: SafeResourceUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
    this.getGodotSrc()
  );
  readonly loading = signal(true);

  constructor() {
    if (this.secureRedirectUrl) {
      window.location.replace(this.secureRedirectUrl);
    }
  }

  onIframeLoad(): void {
    this.loading.set(false);
  }

  private getSecureRedirectUrl(): string {
    if (window.location.protocol === 'https:' || localHosts.has(window.location.hostname)) {
      return '';
    }

    return `https://${secureGodotHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
  }

  private getGodotSrc(): string {
    const params = new URLSearchParams({ mode: this.mode });
    if (this.roomCode) {
      params.set('roomCode', this.roomCode);
    }

    return `/assets/godot/acorn-guild-game/index.html?${params.toString()}`;
  }
}
